import Image from 'next/image'
import { useRouter } from "next/router"

import { ISDG } from "@api/schema"
import { withDynamicNamespaces } from '@components/hoc/withDynamicNamespaces'
import { NamespaceShortcut, useDynamicTranslation } from "@services/i18n"
import { useTooltip } from "@services/tooltipHook"

import { sdgPathCreatorFunction } from "./contentmanagement/sdgHelper"


const usedNamespaces: NamespaceShortcut[] = ["sdg"]

interface IProps {
  className?: string
  /**
   * unique key to be used for lists, e.g. when map(ing) an ISDG[]
   *
   * @see https://legacy.reactjs.org/docs/reconciliation.html#recursing-on-children
   */
  key?: string
  /** if href the image is wrapped into a link */
  href?: string
  /** the SDG whose image should be displayed */
  sdg: ISDG
  /** tooltip shown? true by default. may be disabled, e.g. when interacting with surrounding elements with tooltip */
  tooltip?: boolean
  /** width (and height) of the image. 100 by default */
  width?: number
}


/**
 * This component provides a single SDG image element
 * depending on the current users locale, showing a tooltip by default
 */
const SDGElement: React.FC<IProps> = (props: IProps) => {
  const router = useRouter()
  const t = useDynamicTranslation()

  const {
    className,
    href,
    key,
    sdg,
    tooltip = true,
    width = 100
  } = props

  const { tooltipTargetRef, ToolTip } = useTooltip(t("sdg", `title.${sdg.id}`))

  const image = <Image
    src={sdgPathCreatorFunction(sdg.id, router.locale)}
    alt={t("sdg", `title.${sdg.id}`)}
    layout="intrinsic"
    width={width}
    height={width}
    objectFit="scale-down"
    priority
  />

  return href
    ? <>
      <a
        href={href}
        className={className || "image-filteritem image-filteritem-grid-element btn"}
        ref={tooltipTargetRef}
        key={key}
      >
        {image}
      </a>
      {tooltip && ToolTip}
    </>
    : <span
      ref={tooltipTargetRef}
      className={className || "image-filteritem image-filteritem-grid-element not-clickable"}
    >
      {image}
      {tooltip && ToolTip}
    </span>
}

export default withDynamicNamespaces<IProps>(SDGElement, usedNamespaces)